import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Badge } from '@/components/ui/badge'
import { cn } from '@/lib/utils'
import type { BankStatus } from '@/src/types/admin/analytics'

const statusConfig: Record<BankStatus, { label: string; badgeClass: string; dotClass: string }> = {
  healthy: {
    label: 'ปกติ',
    badgeClass: 'bg-green-100 text-green-700 border-green-200',
    dotClass: 'bg-green-500',
  },
  degraded: {
    label: 'ช้า',
    badgeClass: 'bg-amber-100 text-amber-700 border-amber-200',
    dotClass: 'bg-amber-500',
  },
  down: {
    label: 'ขัดข้อง',
    badgeClass: 'bg-red-100 text-red-700 border-red-200',
    dotClass: 'bg-red-500',
  },
}

interface BankStatusCardProps {
  bankCode: string
  successRate: number
  avgResponseMs: number
  p95ResponseMs?: number
  status: BankStatus
}

export function BankStatusCard({
  bankCode,
  successRate,
  avgResponseMs,
  p95ResponseMs,
  status,
}: BankStatusCardProps) {
  const cfg = statusConfig[status]
  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-sm font-medium">{bankCode}</CardTitle>
        <span className="flex items-center gap-1.5">
          <span className={cn('h-2 w-2 rounded-full', cfg.dotClass)} />
          <Badge variant="outline" className={cn('text-xs', cfg.badgeClass)}>
            {cfg.label}
          </Badge>
        </span>
      </CardHeader>
      <CardContent>
        <div className="text-2xl font-bold">{successRate.toFixed(1)}%</div>
        <p className="text-xs text-muted-foreground mt-1">
          avg {avgResponseMs.toFixed(0)} ms
          {p95ResponseMs !== undefined && ` · P95 ${p95ResponseMs.toFixed(0)} ms`}
        </p>
      </CardContent>
    </Card>
  )
}
